import React, { useState, useEffect } from "react";
import EmptyCourseDash from "../../Components/share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../Components/share/modal/Modal";
import SurveyModal from "../../Components/layouts/AdminDashboard/SurveyModal";
import SurveyTable from "../../Components/layouts/AdminDashboard/SurveyTable";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import MainPagination from "../../Components/share/Pageination/MainPagination";
import useFetch from "../../Hooks/useFetch";

function Survey() {
    const [newSurvey, setNewSurvey] = useState(false);
    const [surveys, setSurveys] = useState("");
    const [surveyQuestions, setSurveyQuestions] = useState("");
    const [surveyType, setSurveyType] = useState("EndCourse");
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getSurveys = useFetch({
        method: "GET",
        url: `BootCampSurveyQuestionService/11/surveys`,
        noHeader: false,
        trigger: true,
        setter: setSurveys,
    });
    // //TODO : id bootcamp dynamic she

    const getSurveysQuestions = useFetch({
        method: "GET",
        url: `BootCampSurveyQuestionService/11/surveys/?type=${surveyType}`,
        noHeader: false,
        trigger: true,
        setter: setSurveyQuestions,
    });

    useEffect(() => {
        getSurveysQuestions.reFetch();
    }, [surveyType]);

    useEffect(() => {
        getSurveys.reFetch();
    }, [pagination]);

    return (
        <div>
            {surveys.results?.length === 0 ? (
                <EmptyCourseDash name="نظرسنجی" show={setNewSurvey} />
            ) : (
                <div>
                    <div className=" flex SupportTicket__header justify-between items-center leading-[3.2rem] mt-[4.5rem]">
                        <h3 className=" text-[#77498F] text-[1.6rem] font-bold leading-[3.2rem] ">
                            اطلاعات نظرسنجی های بوت کمپ
                        </h3>
                        <BtnPrimary
                            text="+ ایجاد نظرسنجی جدید"
                            className=" px-12 py-8 "
                            onClick={() => setNewSurvey(true)}
                        />
                    </div>
                    <SurveyTable list={surveys?.results} />
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={surveys?.results}
                        pageSize={surveys?.page_count}
                        className="mt-[3rem]"
                    />
                </div>
            )}
            <Modal show={newSurvey}>
                <SurveyModal
                    getSurveysQuestions={getSurveysQuestions}
                    surveyQuestions={surveyQuestions}
                    surveyType={surveyType}
                    setSurveyType={setSurveyType}
                    close={setNewSurvey}
                />
            </Modal>
        </div>
    );
}

export default Survey;
